<template>
  <div>
    自定义添加/编辑组件
  </div>
</template>
<script>
  export default {
    name: 'demo-add-form',
    props: {
      formConfig: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    methods: {
      handleSubmit() {
        console.log(this.formConfig)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/custom/components/grid-add-forms/demo-add-form.vue